<template>
    <LazyClientOnly>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="none"
            v-bind="$attrs"
            width="16"
            height="16">
            <path
                d="M7.58391 0.629746C7.71426 0.235397 8.28183 0.235397 8.41218 0.629746L10.0022 5.43999C10.0605 5.61634 10.2277 5.73575 10.4163 5.73575H15.5618C15.9836 5.73575 16.159 6.26634 15.8177 6.51006L11.655 9.48295C11.5024 9.59195 11.4385 9.78515 11.4968 9.9615L13.0868 14.7717C13.2172 15.1661 12.758 15.494 12.4167 15.2503L8.25399 12.2774C8.10138 12.1684 7.89472 12.1684 7.7421 12.2774L3.57936 15.2503C3.2381 15.494 2.77893 15.1661 2.90928 14.7717L4.4993 9.9615C4.5576 9.78515 4.49373 9.59195 4.34112 9.48295L0.178379 6.51006C-0.162886 6.26634 0.012501 5.73575 0.434328 5.73575H5.57975C5.7684 5.73575 5.93559 5.61634 5.99389 5.43999L7.58391 0.629746Z"
                :fill="`url(#${randomID})`" />
            <defs>
                <linearGradient
                    :id="randomID"
                    x1="-0.00195313"
                    y1="7.83398"
                    x2="15.998"
                    y2="7.83398"
                    gradientUnits="userSpaceOnUse">
                    <stop
                        stop-color="#F7CE45"
                        :offset="fillPercent" />
                    <stop
                        stop-color="#CCCCCC"
                        :offset="fillPercent" />
                </linearGradient>
            </defs>
        </svg>
    </LazyClientOnly>
</template>

<script setup lang="ts">
const props = defineProps({
    fillPercent: {
        type: Number as PropType<number>,
        required: true,
    },
})

const randomID = `star_gradient_${getRandomNumber(0, 1000)}_${props.fillPercent}`
</script>
